import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import KampoPage from '../pages/kampo/page';
import FatiguePage from '../pages/fatigue/page';
import OTCPage from '../pages/otc/page';
import VitiligoPage from '../pages/vitiligo/page';
import AlopeciaPage from '../pages/alopecia/page';
import NotFound from '../pages/NotFound';
import PsoriasisPage from '../pages/psoriasis/page';
import Palmoplantar from '../pages/palmoplantar-pustulosis/page';
import DispensingPage from '../pages/dispensing/page';
import HealthConsultationPage from '../pages/health-consultation/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: 'dispensing',
    element: <DispensingPage />,
  },
  {
    path: 'otc',
    element: <OTCPage />,
  },
  {
    path: 'kampo',
    element: <KampoPage />,
  },
  {
    path: 'health-consultation',
    element: <HealthConsultationPage />,
  },
  {
    path: 'fatigue',
    element: <FatiguePage />,
  },
  {
    path: 'vitiligo',
    element: <VitiligoPage />,
  },
  {
    path: 'alopecia',
    element: <AlopeciaPage />,
  },
  {
    path: 'psoriasis',
    element: <PsoriasisPage />,
  },
  {
    path: 'palmoplantar-pustulosis',
    element: <Palmoplantar />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
